/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaListModel } from "@xala/common";

const typesCodes: { [key: string]: string } = {
  SERIES: "programms",
  VOD: "videos",
  EVENT: "videos",
  EPISODE: "videos",
  ALBUM: "podcasts",
  PODCAST: "audios",
};

export const handleTypes = (MediaList: IMediaListModel) => {
  const count: { [key: string]: number } = {
    programms: 0,
    videos: 0,
    podcasts: 0,
    audios: 0,
  };

  let totalCount = 0;

  MediaList?.AllPagesTypes?.forEach(({ TypeCode, Count }) => {
    const mappedKey = typesCodes[TypeCode];

    if (mappedKey && typeof count[mappedKey] === "number") {
      count[mappedKey] += Count;
      totalCount += Count;
    }
  });

  return [
    {
      name: "SEE_ALL",
      key: "all",
      params: null,
      count: totalCount,
    },
    {
      name: "PROGRAMES_SEARCH",
      key: "programms",
      params: ["SERIES"],
      count: count.programms,
    },
    {
      name: "VIDEOS_SEARCH",
      key: "videos",
      params: ["VOD", "EVENT", "EPISODE"],
      count: count.videos,
    },
    {
      name: "PODCASTS_SEARCH",
      key: "podcasts",
      params: ["ALBUM"],
      count: count.podcasts,
    },
    {
      name: "AUDIOS_SEARCH",
      key: "audios",
      params: ["PODCAST"],
      count: count.audios,
    },
  ];
};
